<template>
  <div class="pa-4">
    <div>
      <span class="text_style"> Livestream Details </span>
      <div class="mt-4">
        <span class="h1_tab2"
          >Is this a Livestream course? (aired Live through Livestream platform)
        </span>
        <v-radio-group v-model="LivestreamSelection" row>
          <v-radio
            value="LivestreamYes"
            class="mr-7"
            @click="LivestreamDialog = true"
          >
            <template v-slot:label>
              <div class="">Yes</div>
            </template>
          </v-radio>
          <v-radio value="LivestreamNo">
            <template v-slot:label>
              <div class="">No</div>
            </template>
          </v-radio>
        </v-radio-group>
      </div>
      <div>
        <div class="my-4">
          <span><b> If yes, enter these details: </b></span>
        </div>
        <v-row>
          <v-col cols="12" md="4">
            <v-row>
              <v-col cols="12" md="6">
                <span> Start Date </span>
                <div class="my-3">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        single-line
                        hide-details=""
                        v-model="date"
                        label=""
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <span> End Date </span>
                <div class="my-3">
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        single-line
                        hide-details=""
                        v-model="date"
                        label=""
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu2 = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu2.save(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <div class="my-3">
        <span>
          <span style="color: red"> KEEP THIS NOTE HERE FOR NOW:<br /></span>
          PENDING ROOTPOINTERS/IBA DISCUSSION - DEPENDS ON WHICH LIVESTREAM
          PLATFORM IS USED, WE DON’T KNOW WHAT OTHER DETAILS NEED TO BE ADDED
          HERE
        </span>
        <div>
          <v-text-field dense> </v-text-field>
        </div>
      </div>
      <div class="my-4">
        <span class="text_style"> Course Organization </span>
        <div class="my-3">
          <span>
            Every event must have at least one Session (top-level category) and
            one Part (can contain text, video, and/or handouts).
          </span>
        </div>
      </div>
      <div class="my-3">
        <span class="text_style"> Sessions </span>
        <div>
          <v-row>
            <v-col cols="12" md="5">
              <table style="width: 100%">
                <tr>
                  <th>Sequence <span class="pl-10"> </span></th>
                  <th>Session Name</th>
                  <th>Number Of Parts</th>
                </tr>
                <tr>
                  <td>1</td>
                  <td>Day 1</td>
                  <td>4</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Day 2</td>
                  <td>2</td>
                </tr>
              </table>
            </v-col>
          </v-row>
        </div>
      </div>
      <div>
        <v-btn
          link
          text
          color="primary"
          class="text_trsn"
          @click="dialog = true"
        >
          + Add Session
        </v-btn>
      </div>
      <div class="my-5">
        <div class="py-3">
          <span class="text_style"><b> Parts </b></span>
        </div>
        <div>
          <v-row>
            <v-col cols="12" md="8">
              <table style="width: 100%">
                <tr>
                  <th>In Session #</th>
                  <th>Sequence</th>
                  <th>part Name</th>
                  <th>video</th>
                  <th>Handouts</th>
                </tr>
                <tr>
                  <td>1</td>
                  <td>1</td>
                  <td>Part1</td>
                  <td>Study-Group-LS1.mp4</td>
                  <td>2</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>2</td>
                  <td>Part1</td>
                  <td>Study-Group-LS1.mp4</td>
                  <td>0</td>
                </tr>
              </table>
            </v-col>
          </v-row>
        </div>
        <div>
          <v-btn
            link
            text
            color="primary"
            class="text_trsn"
            @click="dialogparts = true"
          >
            + Add Part
          </v-btn>
        </div>
        <v-dialog v-model="dialog" persistent max-width="400">
          <v-card>
            <div class="pa-5 pb-0">
              <div class="d-flex justify-space-between">
                <div>
                  <span class="text_style"><b>Add Session</b> </span>
                </div>
                <div class="">
                  <v-icon @click="dialog = false"> mdi-close </v-icon>
                </div>
              </div>
            </div>
            <div class="pa-5">
              <span>
                <b>Set Sequence</b>
              </span>
              <div class="my-3">
                <v-text-field
                  dense
                  outlined
                  single-line
                  hide-details=""
                  label=""
                >
                </v-text-field>
              </div>
              <span>
                <b> Set Session Name </b>
              </span>
              <div class="my-3">
                <v-text-field
                  dense
                  outlined
                  single-line
                  hide-details=""
                  label=""
                >
                </v-text-field>
              </div>
            </div>

            <v-card-actions class="pa-5">
              <v-spacer></v-spacer>
              <v-btn
                color="gray darken-1"
                text
                @click="dialog = false"
                depressed
              >
                Cancel
              </v-btn>
              <v-btn color="primary" @click="dialog = false" depressed>
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogparts" persistent max-width="700">
          <v-card>
            <div class="pa-10 pb-0">
              <div class="d-flex justify-space-between">
                <div>
                  <span class="text_style"><b>Add Parts</b> </span>
                </div>
                <div class="">
                  <v-icon @click="dialogparts = false"> mdi-close </v-icon>
                </div>
              </div>
            </div>
            <div class="pa-10 pt-0">
              <div>
                <v-row>
                  <v-col cols="12" md="6">
                    <div class="py-4">
                      <span>Select Session this Part belongs to: </span>
                    </div>
                    <div>
                      <v-select
                        dense
                        outlined
                        single-line
                        hide-details=""
                        label="Session 1"
                      >
                      </v-select>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <div class="pb-4">
                      <span>Set Part name </span>
                    </div>
                    <div>
                      <v-text-field
                        dense
                        outlined
                        single-line
                        hide-details=""
                        label="[part 1 other name]"
                      >
                      </v-text-field>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <div class="pb-4">
                      <span>Set Sequence within Session </span>
                    </div>
                    <div>
                      <v-text-field
                        dense
                        outlined
                        single-line
                        hide-details=""
                        label="1"
                      >
                      </v-text-field>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <div class="pb-4">
                    <span>Add Course Text(optional) </span>
                  </div>
                  <v-col cols="12">
                    <div>
                      <vue-editor
                        useCustomImageHandler
                        v-model="content"
                      ></vue-editor>
                    </div>
                  </v-col>
                </v-row>
                <div class="my-6">
                  <span>Add video (URL or Upload or Retrieve)(Optional) </span>
                </div>
                <v-row>
                  <v-col cols="12" md="6">
                    <div>
                      <v-text-field
                        v-if="!Src"
                        dense
                        outlined
                        single-line
                        hide-details=""
                        label="[video URL, find or name?]"
                        prepend-icon=""
                      >
                      </v-text-field>
                      <video
                        style="width: 100%"
                        height="200"
                        v-else
                        dense
                        controls
                        outlined
                        :src="Src"
                        ref="UrlUploadFile"
                      ></video>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div class="d-flex align-center">
                      <v-icon
                        class="mt-2"
                        color="red"
                        @click="deleteSrc((Src = null))"
                        >mdi-delete
                      </v-icon>
                      <div class="upload-btn-wrapper">
                        <v-btn color="primary" class="ml-6" @click="UploadImg"
                          >Upload</v-btn
                        >
                        <input
                          type="file"
                          style="display: none"
                          ref="Img"
                          accept="video/mp4,video/x-m4v,video/*"
                          @change="SetImage"
                        />
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <div class="mt-3 mb-1">
                    <span
                      >Video thumbnail image (1920 x 1080px) (required if video
                      was added)
                    </span>
                  </div>
                  <v-col cols="12" md="6">
                    <div>
                      <v-file-input
                        dense
                        outlined
                        single-line
                        hide-details=""
                        label="Upload/Replace"
                        prepend-icon=""
                      >
                      </v-file-input>
                    </div>
                  </v-col>
                </v-row>

                <div class="mt-3 mb-1">
                  <span>Digital handout(s) (optional) </span>
                </div>
                <v-row class="my-2">
                  <v-col cols="12" md="6">
                    <div>
                      <v-text-field
                        dense
                        outlined
                        single-line
                        hide-details=""
                        label="[Upload]"
                        prepend-icon=""
                      >
                      </v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" md="1">
                    <div class="d-flex justify-space-between">
                      <v-icon class="mt-2" color="red">mdi-delete </v-icon>
                    </div>
                  </v-col>
                </v-row>
                <div
                  v-for="(div, index) in divs"
                  :key="div.id"
                  :div="(div = index)"
                >
                  <v-row class="my-2">
                    <v-col cols="12" md="6">
                      <div>
                        <v-text-field
                          dense
                          outlined
                          single-line
                          hide-details=""
                          label="[Upload]"
                          prepend-icon=""
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" md="1">
                      <div class="d-flex justify-space-between">
                        <v-icon
                          class="mt-2"
                          color="red"
                          dark
                          @click="deleteRow(index)"
                          >mdi-delete
                        </v-icon>
                      </div>
                    </v-col>
                  </v-row>
                </div>
                <div>
                  <v-btn text color="primary" class="text-trans" @click="addRow"
                    >+ Add another handout
                  </v-btn>
                </div>
              </div>
            </div>

            <v-card-actions class="pa-10">
              <v-spacer></v-spacer>
              <v-btn
                color="gray darken-1"
                text
                @click="dialogparts = false"
                depressed
              >
                Cancel
              </v-btn>
              <v-btn
                class="px-10 py-5"
                color="primary"
                @click="dialogparts = false"
                depressed
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
  components: { VueEditor },
  data: () => ({
    dialogparts: false,
    dialog: false,
    menu: false,
    modal: false,
    menu2: false,
    div: 0,
    divs: [],
    Src: null,
  }),
  methods: {
    UploadImg() {
      this.$refs.Img.click();
    },
    SetImage() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src = reader.result;
        // this.$refs.FileReader.src = reader.result;
      };
      reader.readAsDataURL(this.$refs.Img.files[0]);
    },
    addRow() {
      this.divs.push({
        div: this.div,
      });
    },
    deleteRow(index) {
      this.divs.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.text-trans {
  text-transform: none;
}
table,
th,
td {
  border: 1px solid white;
  border-collapse: collapse;
}
th,
td {
}
.text_style {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;

  line-height: 28px;
}
.text_trsn {
  text-transform: none;
}
</style>
